const languageData = [
  {
    languageId: "english",
    locale: "en",
    name: "English",
    icon: "us",
  },
  {
    languageId: "russian",
    locale: "ru",
    name: "Русский",
    icon: "ru",
  },
];
export default languageData;
